// @flow
import * as React from 'react'
import { Helmet } from 'react-helmet'
import ScrollToTopOnMount from './ScrollToTopOnMount'

const lego = window.lego

type Props = {
  title?: string,
  description?: string,
  urlPath?: string,
  schema: {} | {}[],
  metatags: {}[],
  children: React.Node,
}

export default class Page extends React.Component<Props> {
  static defaultProps = {
    schema: [],
    metatags: [],
  }

  render = () => {
    return (
      <React.Fragment>
        <ScrollToTopOnMount />

        <Helmet>
          {this.renderCanonicalMaybe()}
          {this.renderTitleMaybe()}
          {this.renderDescriptionMaybe()}
          {this.renderSchema()}
          {this.renderMetatags()}
        </Helmet>

        {this.props.children}
      </React.Fragment>
    )
  }

  renderCanonicalMaybe = () => {
    if (this.props.urlPath === undefined) return

    return <link rel="canonical" href={`${lego.config.DOMAIN}${this.props.urlPath}`} />
  }

  renderTitleMaybe = () => {
    if (this.props.title === undefined) return

    return <title>{this.props.title}</title>
  }

  renderDescriptionMaybe = () => {
    if (this.props.description === undefined) return

    return <meta name="description" content={this.props.description} />
  }

  renderSchema = () => {
    return <script type="application/ld+json">{JSON.stringify(this.props.schema)}</script>
  }

  renderMetatags = () => {
    return this.props.metatags.map(props => <meta {...props} key={JSON.stringify(props)} />)
  }
}
